const TEST_IDS = {
  tokenTextField: 'repay-modal-token-text-field',
  selectTokenTextField: 'repay-modal-select-token-text-field',
  spendingLimit: 'spending-limit',
};

export default TEST_IDS;
